// extracted by mini-css-extract-plugin
export default {"linkStyle":"JavneNabavke_linkStyle__xn+Fv","iframeStyle":"JavneNabavke_iframeStyle__kJmsv"};